<template>
  <ubi-panel style="background-color: #EBF3F2;">
    <ubi-search-container
        v-on:resetfilter="resetSearchTab()"
        v-on:filter="$emit('do-filter', $event)"
    >
      <div>
        <el-row>
          <el-col :span="11" class="mr-5">
            <el-form-item no-help :label="$t('general.filters.openSearch')">
              <el-input type="text" @input="changeSearch()" v-model="rechercheLibre" :placeholder="$t('general.filters.adReferencePlaceholder')" />
            </el-form-item>
          </el-col>
<!--          Une fois dev réalisé, rajouter ce filtre pour la date de diff-->
<!--          <el-col :span="11" class="mr-5">-->
<!--            <el-row>-->
<!--              <el-col>-->
<!--                <el-form-item label="Chercher par date de diffusion">-->
<!--                  <el-date-picker-->
<!--                      type="daterange"-->
<!--                      :value="[-->
<!--                      after || undefined,-->
<!--                      before || undefined-->
<!--                    ]"-->
<!--                      v-model="dateSearch"-->
<!--                      :start-placeholder="$t('general.filters.dateCreationStart')"-->
<!--                      :end-placeholder="$t('general.filters.dateCreationEnd')"-->
<!--                      @input="dates => changeDate({ after: dates[0], before: dates[1] })"-->
<!--                      format="dd/MM/yyyy"-->
<!--                  >-->
<!--                  </el-date-picker>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </el-col>-->
        </el-row>
<!--        <el-row style="margin-top: 30px;" v-if="activeTab == 'Annonces'">-->
<!--          <el-col>-->
<!--            <el-radio-group v-model="network" @change="changeNetwork()">-->
<!--              <el-radio label="allPosts">Tous les posts</el-radio>-->
<!--              <el-radio label="INSTAGRAM_IMMO">Instagram</el-radio>-->
<!--              <el-radio label="FACEBOOK_POST_IMMO">Facebook</el-radio>-->
<!--              <el-radio label="GOOGLE_MY_BUSINESS_IMMO">GMB</el-radio>-->
<!--              <el-radio label="LINKEDIN_IMMO">LinkedIn</el-radio>-->
<!--            </el-radio-group>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row style="margin-top: 30px;" v-if="activeTab == 'BienVendus'">-->
<!--          <el-col>-->
<!--            <el-radio-group v-model="network" @change="changeNetwork()">-->
<!--              <el-radio label="allPosts">Tous les posts</el-radio>-->
<!--              <el-radio label="INSTAGRAM_IMMO_BIENS_VENDUS">Instagram</el-radio>-->
<!--              <el-radio label="FACEBOOK_POST_IMMO_BIENS_VENDUS">Facebook</el-radio>-->
<!--              <el-radio label="GOOGLE_MY_BUSINESS_IMMO_BIENS_VENDUS">GMB</el-radio>-->
<!--              <el-radio label="LINKEDIN_IMMO_BIENS_VENDUS">LinkedIn</el-radio>-->
<!--            </el-radio-group>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row style="margin-top: 30px;" v-if="activeTab == 'PostsEditoriaux'">-->
<!--          <el-col>-->
<!--            <el-radio-group v-model="network" @change="changeNetwork()">-->
<!--              <el-radio label="allPosts">Tous les posts</el-radio>-->
<!--              <el-radio label="INSTAGRAM_EDITO">Instagram</el-radio>-->
<!--              <el-radio label="FACEBOOK_EDITO">Facebook</el-radio>-->
<!--              <el-radio label="GOOGLE_MY_BUSINESS_EDITO">GMB</el-radio>-->
<!--              <el-radio label="LINKEDIN_EDITO">LinkedIn</el-radio>-->
<!--            </el-radio-group>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </div>
    </ubi-search-container>
  </ubi-panel>
</template>

<script>

export default {
  name: 'SocialPostsListSearch',
  props: ['activeTab'],
  data () {
    return {
      filters: [
        { value: 'allPosts', label: 'Tous les posts' },
        { value: 'instagram', label: 'Instagram' },
        { value: 'facebook', label: 'Facebook' },
        { value: 'googlemybusiness', label: 'GMB' },
        { value: 'linkedin', label: 'LinkedIn' }
      ],
      networks: [],
      dateSearch: null,
      network: '',
      type: null,
      after: null,
      before: null,
      rechercheLibre: ''
    }
  },
  computed: {
  },
  watch: {
    activeTab: function (val) {
      switch (val) {
        case 'Annonces' :
          this.network = this.$store.getters['socialPostsTableAnnonces/getNetwork']
          this.rechercheLibre = this.$store.getters['socialPostsTableAnnonces/getSearch']
          break
        case 'BienVendus' :
          this.network = this.$store.getters['socialPostsTableBiensVendus/getNetwork']
          this.rechercheLibre = this.$store.getters['socialPostsTableBiensVendus/getSearch']
          break
        case 'PostsEditoriaux' :
          this.network = this.$store.getters['socialPostsTableBiensVendus/getNetwork']
          this.rechercheLibre = this.$store.getters['socialPostsTableBiensVendus/getSearch']
          break
      }
    }
  },
  methods: {
    changeSearch () {
      switch (this.activeTab) {
        case 'Annonces':
          this.$store.commit('socialPostsTableAnnonces/setSearch', this.rechercheLibre)
          break
        case 'BienVendus':
          this.$store.commit('socialPostsTableBiensVendus/setSearch', this.rechercheLibre)
          break
        case 'PostsEditoriaux':
          this.$store.commit('socialPostsTableEditoriaux/setSearch', this.rechercheLibre)
          break
      }
    },
    changeDate (date) {
      switch (this.activeTab) {
        case 'Annonces':
          this.$store.commit('socialPostsTableAnnonces/setDateDiff', date)
          break
        case 'BienVendus':
          this.$store.commit('socialPostsTableBiensVendus/setDateDiff', date)
          break
        case 'PostsEditoriaux':
          this.$store.commit('socialPostsTableEditoriaux/setDateDiff', date)
          break
      }
    },
    changeNetwork () {
      switch (this.activeTab) {
        case 'Annonces':
          this.$store.commit('socialPostsTableAnnonces/setNetwork', this.network)
          break
        case 'BienVendus':
          this.$store.commit('socialPostsTableBiensVendus/setNetwork', this.network)
          break
        case 'PostsEditoriaux':
          this.$store.commit('socialPostsTableEditoriaux/setNetwork', this.network)
          break
      }
    },
    resetSearchTab () {
      switch (this.activeTab) {
        case 'Annonces':
          this.$store.commit('socialPostsTableAnnonces/setNetwork', null)
          this.network = null
          this.$store.commit('socialPostsTableAnnonces/setSearch', '')
          this.rechercheLibre = ''
          this.$store.dispatch('socialPostsTableAnnonces/loadSocialPostsAnnonces')
          break
        case 'BienVendus':
          this.$store.commit('socialPostsTableBiensVendus/setNetwork', null)
          this.network = null
          this.$store.commit('socialPostsTableBiensVendus/setSearch', '')
          this.rechercheLibre = ''
          this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
          break
        case 'PostsEditoriaux':
          this.$store.commit('socialPostsTableEditoriaux/setNetwork', null)
          this.network = null
          this.$store.commit('socialPostsTableEditoriaux/setSearch', '')
          this.rechercheLibre = ''
          this.$store.dispatch('socialPostsTableEditoriaux/loadSocialPostsEditoriaux')
          break
      }
    }
  }
}

</script>

<style scoped>
.el-date-editor {
  width: 100%;
}
</style>
